// React
import React, { useState } from "react";
import { Form, Container } from "react-bootstrap";
import { useParams } from "react-router-dom";

// Components
import LoaderButton from "../components/LoaderButton";
import { useFormFields } from "../libs/hooksLib";

// Eventify API
import * as EventifyAPI from "../libs/EventifyAPI";

// AWS
import { Auth } from "aws-amplify";
import { GoogleLogin } from 'react-google-login';

// Local Storage
import ls from 'local-storage';

export default function SignupPage(props) {
  let { org } = useParams();

  const [fields, handleFieldChange] = useFormFields({
    email: "",
    password: "",
    confirmPassword: "",
    confirmationCode: ""
  });
  const [newUser, setNewUser] = useState(null);
  const [organizationId, setOrganizationId] = useState(null);
  const [isLoading, setIsLoading] = useState(false);

  function validateForm() {
    return (
      fields.email.length > 0 &&
      fields.password.length > 0 &&
      fields.password === fields.confirmPassword
    );
  }

  function validateConfirmationForm() {
    return fields.confirmationCode.length > 0;
  }

  async function handleSubmit(event) {
    event.preventDefault();

    setIsLoading(true);

    try {
      const invitedUser = await EventifyAPI.getInvitedUserByEmail(fields.email);
      if (!invitedUser) {
        setIsLoading(false);
        return alert("You have not received an invite");
      }

      setOrganizationId(invitedUser.organizationId);

      const newUser = await Auth.signUp({
        username: fields.email,
        password: fields.password
      });
      setIsLoading(false);
      setNewUser(newUser);
    } catch (e) {
      alert(e.message);
      setIsLoading(false);
    }
  }

  async function handleConfirmationSubmit(event) {
    event.preventDefault();

    setIsLoading(true);

    try {
      await Auth.confirmSignUp(fields.email, fields.confirmationCode);
      await Auth.signIn(fields.email, fields.password);

      const authData = {"providerType": "amazon", "email": fields.email};
      ls.set('authData', authData);
      ls.set("organizationid", organizationId);

      // TODO: create a user account
      props.userHasAuthData(authData);
      props.history.push("/");
    } catch (e) {
      alert(e.message);
      setIsLoading(false);
    }
  }

  function renderConfirmationForm() {
    return (
      <form onSubmit={handleConfirmationSubmit}>
        <Form.Group controlId="confirmationCode" bssize="large">
          <Form.Label>Confirmation Code</Form.Label>
          <Form.Control
            autoFocus
            type="tel"
            onChange={handleFieldChange}
            value={fields.confirmationCode}
          />
          <Form.Text>Please check your email for the code.</Form.Text>
        </Form.Group>
        <LoaderButton
          block
          type="submit"
          bssize="large"
          isLoading={isLoading}
          disabled={!validateConfirmationForm()}
        >
          Verify
        </LoaderButton>
      </form>
    );
  }

  const successResponseGoogle = async (response) => {
    // Add the Google access token to the Cognito credentials login map.
     // AWS.config.credentials = new AWS.CognitoIdentityCredentials({
     //    IdentityPoolId: config.cognito.IDENTITY_POOL_ID,
     //    Logins: {
     //       'accounts.google.com': authResult['id_token']
     //    }
     // });
     //
     // // Obtain AWS credentials
     // AWS.config.credentials.get(async function(){
     //   try {
     //     await Auth.currentSession();
     //     userHasAuthenticated(true);
     //   } catch (e) {
     //     if (e !== "No current user") {
     //       alert(e);
     //     }
     //   }
     // });
     //

     // TODO: consolidate w/ login.js repeated code (auth lib?)
     // since this also signs a new user up if they don't exist in db yet, a check
     // is run server-side to see if they were invited (if user doesn't exist)
     let result;
     try {
       result = await EventifyAPI.authenticateGoogleSignIn(response);
     } catch (err) {
       alert(`Error: ${err.message}`)
     }

     setOrganizationId(result.organizationId);

     ls.set("authData", result.user);
     ls.set("organizationid", result.organizationid);

     props.userHasAuthData(result);
  }

  const failureResponseGoogle = (response) => {

  }

  function renderForm() {
    return (
      <div>
        <form onSubmit={handleSubmit}>
          <Form.Group controlId="email">
            <Form.Label>Email</Form.Label>
            <Form.Control
              autoFocus
              type="email"
              value={fields.email}
              onChange={handleFieldChange}
            />
          </Form.Group>
          <Form.Group controlId="password">
            <Form.Label>Password</Form.Label>
            <Form.Control
              type="password"
              value={fields.password}
              onChange={handleFieldChange}
            />
          </Form.Group>
          <Form.Group controlId="confirmPassword">
            <Form.Label>Confirm Password</Form.Label>
            <Form.Control
              type="password"
              onChange={handleFieldChange}
              value={fields.confirmPassword}
            />
          </Form.Group>
          <LoaderButton
            block
            type="submit"
            bssize="large"
            isLoading={isLoading}
            disabled={!validateForm()}
          >
            Signup
          </LoaderButton>
        </form>
        <div>
          <div className="google-login">
            <GoogleLogin
              clientId="530469725356-el74ba1asc3g11dpc06ggn71skj4pq9c.apps.googleusercontent.com"
              buttonText="Sign Up"
              offline={false}
              onSuccess={successResponseGoogle}
              onFailure={failureResponseGoogle}
              cookiePolicy={'single_host_origin'}
            />
          </div>
        </div>
      </div>
    );
  }

  return (
    <div className="Signup">
      {newUser === null ? renderForm() : renderConfirmationForm()}
    </div>
  );
}
